export default "/2.f49c53c78d04a8451a4f82e0eb72aadb.png";